export default __webpack_public_path__ + "static/media/mosaic.b3b955e9.png";